/**
 * Created by kldavis on 2/23/17.
 */
var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Classes.DynamicScriptLoaderAsyncConditionalJob = new Class({
    Extends: OCS.Classes.DynamicScriptLoaderJob,
    Implements: [OCS.Classes.DynamicScriptLoaderConditionalJob, OCS.Classes.DynamicScriptLoaderAsyncJob],
    options: {
        'classname': "OCS.Classes.DynamicScriptLoaderAsyncConditionalJob"
    }
});